export enum COUNTER {
  BTN_INCREMENT = "counterBtnIncrement",
  BTN_DECREMENT = "counterBtnDecrement",
  INPUT = "counterInput",
}
